import { render, staticRenderFns } from "./DefaultProjectCode.vue?vue&type=template&id=5ce7a793&"
import script from "./DefaultProjectCode.vue?vue&type=script&lang=js&"
export * from "./DefaultProjectCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports